import { useEffect, useState } from "react";
import L from "leaflet";
import { useTheme } from "@/context/ThemeContext";

const TILES = "https://tile.openstreetmap.org/{z}/{x}/{y}.png";
const ATTR = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

export function useLeafletMap(ref, center = [-6.2, 106.83], zoom = 12) {
  const { theme } = useTheme();
  const [map, setMap] = useState(null);

  useEffect(() => {
    const m = L.map(ref.current, { zoomControl: false }).setView(center, zoom);
    L.control.zoom({ position: "bottomright" }).addTo(m);
    setMap(m);
    const ro = new ResizeObserver(() => m.invalidateSize());
    ro.observe(ref.current);
    return () => {
      ro.disconnect();
      m.remove();
      setMap(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!map) return undefined;
    const layer = L.tileLayer(TILES, { maxZoom: 19, attribution: ATTR, className: theme === "dark" ? "gt-tiles-dark" : "gt-tiles-light" }).addTo(map);
    return () => layer.remove();
  }, [map, theme]);

  return map;
}
